/**
 * Remove inline script tags before assigning HTML to a sandboxed iframe without allow-scripts.
 * Matches server-side stripInlineScriptTagsForIframeEmbed; defensive against caches / older API builds.
 *
 * @param {string} html
 * @returns {string}
 */
export function stripIframePreviewScripts(html) {
  if (typeof html !== 'string') return '';
  return html.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '');
}
